export const getIntegrationLabel = (integration: string | null | undefined): string => {
  if (!integration) return "Unknown";
  
  const integrationLabels: Record<string, string> = {
    jira: "Jira",
    github: "GitHub",
    gitlab: "GitLab",
    asana: "Asana",
    slack: "Slack",
    notion: "Notion",
    "google-sheets": "Google Sheets",
    stripe: "Stripe",
    salesforce: "Salesforce",
    hubspot: "HubSpot",
    linear: "Linear",
    zendesk: "Zendesk",
    typeform: "Typeform",
    twitter: "Twitter",
    google_contacts: "Google Contacts",
  };

  return integrationLabels[integration] || integration.replace("_", " ");
};

export const getAllIntegrationLabels = (): Record<string, string> => {
  return {
    jira: "Jira",
    github: "GitHub",
    gitlab: "GitLab",
    asana: "Asana",
    slack: "Slack",
    notion: "Notion",
    "google-sheets": "Google Sheets",
    stripe: "Stripe",
    salesforce: "Salesforce",
    hubspot: "HubSpot",
    linear: "Linear",
    zendesk: "Zendesk",
    typeform: "Typeform",
    twitter: "Twitter",
    google_contacts: "Google Contacts",
  };
};
